import React from 'react';
import { Link } from 'react-router-dom';

import bnr1 from '../images/banner/bnr1.jpg';
import bnr3 from '../images/lines.png';
import heroBanner from '../images/background/image.png';
// import banner from '../images/background/EMS_9247.jpg';
import { useLanguage } from '../i18n/LanguageContext';

export function StudentsAndGraduates() {
	const { t } = useLanguage();
	return (
		<div className="page-content bg-white">

			<div className="content-block">
				{/* Sección Hero: Presentación Impactante */}

				<div className="dez-bnr-inr overlay-black-middle" style={{ backgroundImage: "url(" + heroBanner + ")", backgroundPosition: "50% 27%" }}>
					<div className="container">
						<div className="dez-bnr-inr-entry">
							<h1 className="text-white" style={{ fontSize: '3rem', fontWeight: 'bold', marginBottom: '20px' }}>{t('students.title')}</h1>
							{false &&
								<div className="breadcrumb-row">
									<ul className="list-inline">
										<li><Link to={"/"}>Inicio</Link></li>
										<li>Estudiantes y Egresados</li>
									</ul>
								</div>
							}
						</div>
					</div>
				</div>

				<div
					className="section-full overlay-white-middle "
					style={{
						paddingBottom: '80px',
						background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 50%, #f0f4f8 100%)'
					}}
				>
					<div className="container">
						<div className="section-head text-center m-b60">
							{/* <h4
									className="m-b10"
									style={{
										fontSize: '2rem',
										fontWeight: 'bold',
										color: '#232323',
										letterSpacing: '-0.02em',
										marginTop: '50px'
									}}
								>
									Estudiantes <span style={{ color: '#009247' }}>–</span> Egresados
								</h4> */}
							<div className="dez-separator-outer m-b20">
								<div className="dez-separator bg-primary" style={{ width: '80px', height: '0px' }}></div>
							</div>
							<p
								className="m-t10 font-20"
								style={{
									maxWidth: '900px',
									margin: '30px auto 0',
									lineHeight: '1.8',
									color: '#4a4a4a'
								}}
							>
								{t('students.subtitle')}
							</p>
						</div>
						<div className="row align-items-center m-t20" style={{ display: 'flex', flexDirection: 'row' }}>
							<div className="col-lg-6 col-md-6 col-sm-12 m-b30">
								<div
									className="p-a40 bg-white radius-sm"
									style={{
										boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
										borderRadius: '16px',
										borderLeft: '5px solid #009247'
									}}
								>
									<div className="font-16" style={{ lineHeight: '32px', color: '#4a4a4a' }}>
										<p className="m-b25" style={{ fontSize: '17px' }}>
											{t('students.graduatesDesc1')}
										</p>
										<p className="m-b25" style={{ fontSize: '17px' }}>
											{t('students.graduatesDesc2')}
										</p>
										<div
											className="p-a25 radius-sm"
											style={{
												background: 'linear-gradient(135deg, #00924715 0%, #00924708 100%)',
												borderLeft: '3px solid #009247'
											}}
										>
											<p className="m-b0 font-16" style={{ fontSize: '17px', color: '#232323' }}>
												{t('students.graduatesHighlight')}
											</p>
										</div>
									</div>
								</div>
							</div>

							{/* Tarjeta CTA Mejorada */}
							<div className="col-lg-6 col-md-6 col-sm-12 m-b30">
								<div
									className="p-a40 radius-sm h-100"
									style={{
										background: 'linear-gradient(135deg, #009247 0%, #007a39 100%)',
										boxShadow: '0 15px 50px rgba(0,146,71,0.3)',
										borderRadius: '16px',
										color: '#fff',
										position: 'relative',
										overflow: 'hidden'
									}}
								>
									{/* Patrón decorativo de fondo */}
									<div
										style={{
											position: 'absolute',
											top: '-50px',
											right: '-50px',
											width: '200px',
											height: '200px',
											background: 'rgba(255,255,255,0.05)',
											borderRadius: '50%',
											zIndex: 0
										}}
									></div>
									<div
										style={{
											position: 'absolute',
											bottom: '-30px',
											left: '-30px',
											width: '150px',
											height: '150px',
											background: 'rgba(255,255,255,0.03)',
											borderRadius: '50%',
											zIndex: 0
										}}
									></div>

									<div className="icon-content text-center" style={{ position: 'relative', zIndex: 1 }}>
										<div className="icon-xl m-b20" style={{ fontSize: '70px', color: '#fff' }}>
											<i className="ti-user"></i>
										</div>
										<h3
											className="m-b15 text-white"
											style={{
												fontSize: '1.8rem',
												fontWeight: 'bold'
											}}
										>
											{t('students.ctaCard')}
										</h3>
										<p
											className="m-b30 font-16 text-white"
											style={{
												opacity: 0.95,
												lineHeight: '1.7'
											}}
										>
											{t('students.ctaCardDesc')}
										</p>
										<div className="m-t30">
											<Link
												to="/register-2?type=applicant"
												className="site-button radius-xl btn-block m-b15"
												style={{
													backgroundColor: '#ffffff',
													borderColor: '#ffffff',
													color: '#009247',
													fontSize: '16px',
													padding: '14px 25px',
													fontWeight: '600',
													transition: 'all 0.3s',
													boxShadow: '0 5px 15px rgba(0,0,0,0.2)'
												}}
												onMouseEnter={(e) => {
													e.target.style.transform = 'translateY(-2px)';
													e.target.style.boxShadow = '0 8px 20px rgba(0,0,0,0.3)';
												}}
												onMouseLeave={(e) => {
													e.target.style.transform = 'translateY(0)';
													e.target.style.boxShadow = '0 5px 15px rgba(0,0,0,0.2)';
												}}
											>
												<span><i className="ti-medall m-r5"></i>{t('students.loginAsStudent')}</span>
											</Link>
											{/* <button
												type="button"
												className="site-button radius-xl btn-block outline outline-2 white"
												style={{
													backgroundColor: 'transparent',
													color: '#ffffff',
													borderColor: '#ffffff',
													borderWidth: '2px',
													fontSize: '16px',
													padding: '14px 25px',
													fontWeight: '600',
													transition: 'all 0.3s'
												}}
												onMouseEnter={(e) => {
													e.target.style.backgroundColor = '#ffffff';
													e.target.style.color = '#009247';
													e.target.style.transform = 'translateY(-2px)';
												}}
												onMouseLeave={(e) => {
													e.target.style.backgroundColor = 'transparent';
													e.target.style.color = '#ffffff';
													e.target.style.transform = 'translateY(0)';
												}}
											>
												<span><i className="ti-id-badge m-r5"></i>No pertenezco a UNICARIBE</span>
											</button> */}
										</div>

										<p
											className="m-t25 m-b0 font-13 text-white"
											style={{
												opacity: 0.85,
												fontSize: '13px'
											}}
										>
											{t('students.comingSoon')}
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* Sección: Una plataforma para cada etapa - Sin fondo de imagen */}
				<div
					className="section-full content-inner-2 overlay-white-middle"
					style={{
						paddingTop: '0px',
						paddingBottom: '90px',
						background: '#ffffff',
						position: 'relative'
					}}
				>
					{/* Patrón decorativo sutil */}
					<div
						style={{
							position: 'absolute',
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,
							// backgroundImage: `url(${banner})`,
							opacity: 0.03,
							backgroundSize: 'cover',
							backgroundPosition: 'center',
							pointerEvents: 'none'
						}}
					></div>

					<div className="container" style={{ position: 'relative', zIndex: 1 }}>
						<div className="section-head text-center m-b60">
							<h2
								className="m-b10"
								style={{
									fontSize: '2.8rem',
									fontWeight: 'bold',
									color: '#232323',
									letterSpacing: '-0.02em'
								}}
							>
								{t('students.platformTitle')}
							</h2>
							<div className="dez-separator-outer m-b20">
								<div className="dez-separator bg-primary" style={{ width: '80px', height: '4px' }}></div>
							</div>
							<p
								className="m-t30 font-18"
								style={{
									maxWidth: '850px',
									margin: '30px auto 0',
									lineHeight: '1.8',
									color: '#4a4a4a'
								}}
							>
								{t('students.platformSubtitle')}
							</p>
						</div>

						<div className="row m-t50">
							<div className="col-lg-4 col-md-6 col-sm-12 m-b30">
								<div
									className="icon-bx-wraper p-a40 center bg-white radius-sm h-100"
									style={{
										boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
										borderRadius: '16px',
										borderTop: '4px solid #009247',
										transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
										cursor: 'pointer'
									}}
									onMouseEnter={(e) => {
										e.currentTarget.style.transform = 'translateY(-10px)';
										e.currentTarget.style.boxShadow = '0 15px 40px rgba(0,146,71,0.2)';
									}}
									onMouseLeave={(e) => {
										e.currentTarget.style.transform = 'translateY(0)';
										e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.1)';
									}}
								>
									<div
										className="icon-xl text-primary m-b25"
										style={{
											fontSize: '70px',
											transition: 'all 0.3s'
										}}
									>
										<i className="ti-user"></i>
									</div>
									<div className="icon-content">
										<h4
											className="m-b15"
											style={{
												fontSize: '1.5rem',
												fontWeight: 'bold',
												color: '#232323'
											}}
										>
											{t('students.forStudents')}
										</h4>
										<p
											className="m-b0 font-16"
											style={{
												lineHeight: '1.8',
												color: '#4a4a4a'
											}}
										>
											{t('students.forStudentsDesc')}
										</p>
									</div>
								</div>
							</div>
							<div className="col-lg-4 col-md-6 col-sm-12 m-b30">
								<div
									className="icon-bx-wraper p-a40 center text-white radius-sm h-100"
									style={{
										background: 'linear-gradient(135deg, #009247 0%, #007a39 100%)',
										boxShadow: '0 8px 30px rgba(0,146,71,0.25)',
										borderRadius: '16px',
										borderTop: '4px solid #ffffff',
										transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
										cursor: 'pointer'
									}}
									onMouseEnter={(e) => {
										e.currentTarget.style.transform = 'translateY(-10px) scale(1.02)';
										e.currentTarget.style.boxShadow = '0 15px 50px rgba(0,146,71,0.35)';
									}}
									onMouseLeave={(e) => {
										e.currentTarget.style.transform = 'translateY(0) scale(1)';
										e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,146,71,0.25)';
									}}
								>
									<div
										className="icon-xl m-b25"
										style={{
											fontSize: '70px',
											color: '#ffffff'
										}}
									>
										<i className="ti-medall"></i>
									</div>
									<div className="icon-content">
										<h4
											className="m-b15 text-white"
											style={{
												fontSize: '1.5rem',
												fontWeight: 'bold'
											}}
										>
											{t('students.forGraduates')}
										</h4>
										<p
											className="m-b0 font-16 text-white"
											style={{
												lineHeight: '1.8',
												opacity: 0.95
											}}
										>
											{t('students.forGraduatesDesc')}
										</p>
									</div>
								</div>
							</div>
							<div className="col-lg-4 col-md-12 col-sm-12 m-b30">
								<div
									className="icon-bx-wraper p-a40 center bg-white radius-sm h-100"
									style={{
										boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
										borderRadius: '16px',
										borderTop: '4px solid #fdba18',
										transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
										cursor: 'pointer'
									}}
									onMouseEnter={(e) => {
										e.currentTarget.style.transform = 'translateY(-10px)';
										e.currentTarget.style.boxShadow = '0 15px 40px rgba(253,186,24,0.2)';
									}}
									onMouseLeave={(e) => {
										e.currentTarget.style.transform = 'translateY(0)';
										e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.1)';
									}}
								>
									<div
										className="icon-xl text-primary m-b25"
										style={{
											fontSize: '70px',
											color: '#fdba18'
										}}
									>
										<i className="ti-briefcase"></i>
									</div>
									<div className="icon-content">
										<h4
											className="m-b15"
											style={{
												fontSize: '1.5rem',
												fontWeight: 'bold',
												color: '#232323'
											}}
										>
											{t('students.forInternships')}
										</h4>
										<p
											className="m-b0 font-16"
											style={{
												lineHeight: '1.8',
												color: '#4a4a4a'
											}}
										>
											{t('students.forInternshipsDesc')}
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>


				{/* Call to Action Final */}
				<div
					className="section-full content-inner-2 overlay-white-middle"
					style={{
						backgroundImage: "url(" + bnr3 + ")",
						backgroundPosition: "center center",
						backgroundRepeat: "no-repeat",
						backgroundSize: "cover",
						paddingTop: '20px',
						paddingBottom: '80px'
					}}
				>
					<div className="container">
						<div className="row">
							<div className="col-lg-10 col-md-12 m-auto text-center">
								<h2
									className="m-b20"
									style={{
										fontSize: '2.5rem',
										fontWeight: 'bold',
										color: '#232323'
									}}
								>
									{t('students.ctaTitle')}
								</h2>
								<p
									className="m-b40 font-18"
									style={{
										maxWidth: '700px',
										margin: '0 auto 40px',
										color: '#4a4a4a',
										lineHeight: '1.8'
									}}
								>
									{t('students.ctaDesc')}
								</p>
								<div className="d-inline-block m-t20">


								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

